import React from 'react'
import PropTypes from 'prop-types'
import { Form, Button } from 'react-bootstrap'
import FormError from 'shared/components/FormError'
import SpinnerLoader from 'shared/components/Loaders/SpinnerLoader'
import {
  beginTotpEnrollment,
  confirmTotpEnrollment,
  registerPasskey,
} from 'Store/Auth/actions/mfaActions'

class MfaLoginEnroll extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      totpSecret: null,
      otpauthUrl: null,
      code: '',
      passkeyName: 'Passkey',
      error: null,
      loading: false,
      totpLoading: false,
    }
    this.loadTotp = this.loadTotp.bind(this)
    this.onTotpSubmit = this.onTotpSubmit.bind(this)
    this.onPasskey = this.onPasskey.bind(this)
  }

  componentDidMount() {
    this.loadTotp()
  }

  loadTotp() {
    this.setState({ totpLoading: true, error: null })
    beginTotpEnrollment({ enrollmentToken: this.props.enrollmentToken })
      .then(resp => {
        this.setState({
          totpSecret: resp.data.secret,
          otpauthUrl: resp.data.otpauth_url,
          totpLoading: false,
        })
      })
      .catch(err => {
        const message = err.response?.data?.detail || 'Could not start authenticator setup.'
        this.setState({ error: { message }, totpLoading: false })
      })
  }

  onTotpSubmit(e) {
    e.preventDefault()
    this.setState({ loading: true, error: null })
    confirmTotpEnrollment(this.state.code.trim(), { enrollmentToken: this.props.enrollmentToken })
      .then(() => this.props.onEnrollmentComplete())
      .catch(err => {
        const message = err.response?.data?.detail || 'Invalid verification code.'
        this.setState({ error: { message }, loading: false })
      })
  }

  onPasskey() {
    this.setState({ loading: true, error: null })
    registerPasskey(this.state.passkeyName, { enrollmentToken: this.props.enrollmentToken })
      .then(resp => {
        if (resp.data.access) {
          this.props.onSuccess(resp.data)
        } else {
          this.props.onEnrollmentComplete()
        }
      })
      .catch(err => {
        const message = err.response?.data?.detail || err.message || 'Passkey registration failed.'
        this.setState({ error: { message }, loading: false })
      })
  }

  render() {
    const { detail } = this.props
    return (
      <div className="login-form__mfa">
        <h5 className="mb-3">Set up two-factor authentication</h5>
        {detail && <p className="login-form__text mb-3">{detail}</p>}
        <FormError show={!!this.state.error} message={(this.state.error || {}).message} />

        <h6 className="mt-3">Authenticator app</h6>
        {this.state.totpLoading && <SpinnerLoader size="24px" />}
        {this.state.totpSecret && (
          <>
            <p className="login-form__text">Add this secret to your app, or use the link on your phone.</p>
            <code className="d-block mb-2 p-2 bg-light">{this.state.totpSecret}</code>
            {this.state.otpauthUrl && (
              <p>
                <a href={this.state.otpauthUrl}>Add in authenticator app</a>
              </p>
            )}
            <Form onSubmit={this.onTotpSubmit}>
              <Form.Group controlId="enrollCode">
                <Form.Label>Verification code</Form.Label>
                <Form.Control
                  value={this.state.code}
                  onChange={e => this.setState({ code: e.target.value })}
                  inputMode="numeric"
                  autoComplete="one-time-code"
                  required
                />
              </Form.Group>
              <Button className="mt-2 btn-loader" disabled={this.state.loading} variant="dark" type="submit">
                <span>Enable authenticator</span>
              </Button>
            </Form>
          </>
        )}

        <h6 className="mt-4">Passkey</h6>
        <Form.Group controlId="passkeyName" className="mb-2">
          <Form.Label>Passkey name</Form.Label>
          <Form.Control
            value={this.state.passkeyName}
            onChange={e => this.setState({ passkeyName: e.target.value })}
          />
        </Form.Group>
        <Button
          className="btn-loader w-100"
          disabled={this.state.loading}
          variant="outline-dark"
          onClick={this.onPasskey}
        >
          <span>Register passkey</span>
        </Button>

        <p className="mt-3 mb-0">
          <button type="button" className="btn btn-link p-0" onClick={this.props.onBack}>
            ← Back to password
          </button>
        </p>
      </div>
    )
  }
}

MfaLoginEnroll.propTypes = {
  enrollmentToken: PropTypes.string.isRequired,
  detail: PropTypes.string,
  onSuccess: PropTypes.func.isRequired,
  onEnrollmentComplete: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
}

export default MfaLoginEnroll
